import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetAdPlatform } from "../queries/adPlatforms";
import { ENTITY } from "../constants";

export const AdPlatformBreadcrumb = ({ match }) => {
  // Entity
  const { ADPLATFORM } = ENTITY;

    const {
      data: adPlatform,
      isLoading,
      isError,
      error,
    } = useGetAdPlatform(match.params.adPlatformId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (adPlatform) {
      return <span>{trimString(adPlatform[ADPLATFORM.nameField], 20)}</span>;
    }
  
    return null;
  };